import { createAction } from 'typesafe-actions';

export const enableKiosk = createAction('ENABLE_KIOSK')<void>();
export const disableKiosk = createAction('DISABLE_KIOSK')<void>();
